import { ChatbotTable } from '@/components-restructure/ChatbotPage/ChatbotTable';
import { useHomepageViewType } from '@/components-restructure/ChatbotPage/HomepageViewSelect';
import AppLanding from '@/components/AppLanding/AppLanding';
import { SubLayout } from '@/components/Layouts';
import { useUpgrade } from '@/components/Modals/UpgradeModal';
import { Success } from '@/components/Success';
import { useTour } from '@/components/tour/TourContext';
import { Separator } from '@/components/ui/Separator';
import useCopyChatbot from '@/hooks/useCopyChatbot';
import { useWorkspaceWithFolderNames } from '@/hooks/useWorkspace';
import { api } from '@/lib/trpc/react';
import { TourType } from '@/types/tour';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { toast } from 'sonner';

const NewPage = () => {
  useCopyChatbot();
  const searchParams = useSearchParams();
  const router = useRouter();
  const { showUpgrade } = useUpgrade();

  const { startTour } = useTour();

  const { data: tours, isLoading } = api.tours.byUser.useQuery();

  const entities = useWorkspaceWithFolderNames();
  const { homepageViewType } = useHomepageViewType();

  const isFirstVisitTourCompleted = tours?.some(
    (tour) => tour.type === TourType.APP_LANDING_FIRST_VISIT && tour.completed,
  );

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (Array.isArray(tours) && !isFirstVisitTourCompleted && !isLoading) {
      timer = setTimeout(() => {
        startTour(TourType.APP_LANDING_FIRST_VISIT);
      }, 2000);
    }
    return () => clearTimeout(timer);
  }, [isFirstVisitTourCompleted]);

  useEffect(() => {
    const showUpsell = searchParams?.get('showUpsell');
    if (showUpsell === 'true') {
      showUpgrade('importLimit');
      router.push('/new');
    }
  }, [searchParams, showUpgrade, router]);

  useEffect(() => {
    const error = searchParams?.get('error');

    if (error === 'true') {
      toast.error('Error importing file: document behind paywall');
      router.push('/new');
    } else if (error === 'max-accounts') {
      toast.error(
        <span>
          Maximum number of accounts for this device reached. Please{' '}
          <button className="cursor-pointer underline" id="intercom_support">
            contact support
          </button>{' '}
          if this is a mistake.
        </span>,
        {
          duration: 7000,
          id: 'max-accounts-error',
        },
      );

      const newSearchParams = new URLSearchParams(searchParams?.toString());
      newSearchParams.delete('error');
      const newUrl = newSearchParams.toString()
        ? `?${newSearchParams.toString()}`
        : '';
      router.replace(`/new${newUrl}`);
    }
  }, [searchParams, router]);

  return (
    <SubLayout className="flex flex-col flex-1 justify-center bg-background">
      {homepageViewType === 'split' && (
        <>
          <AppLanding />
          <Separator className=" bg-borderSecondary !h-[1px]" />
        </>
      )}
      <ChatbotTable data={entities || []} isHomepage tableId="home" />
      <Success />
      {/* <FooterLanding /> */}
    </SubLayout>
  );
};

export default NewPage;
